import { Fragment } from 'react';

import FontIcon from '@/shared/ui/FontIcon';
import { useWiwDispatch } from '@/store';
import { WORKCHAT_VIEWS } from '@/workchat/constants';
import type { HeaderButton } from '@/workchat/v2/components/HeaderV2';
import { viewStackPop, viewStackPush } from '@/workchat/v2/store/reducer';
import HeaderV3 from '@/workchat/v3/components/HeaderV3/HeaderV3';
import WorkChatListItem from '@/workchat/v3/components/WorkChatListItem/WorkChatListItem';

import '@/workchat/v3/components/CreateNewConversation/CreateNewConversation.scss';

export default function CreateNewConversationV3() {
  const dispatch = useWiwDispatch();

  const handleNewMessageClick = () => {
    dispatch(viewStackPush(WORKCHAT_VIEWS.VIEW_NEW_MESSAGE));
  };

  const handleNewChannelClick = () => {
    dispatch(viewStackPush(WORKCHAT_VIEWS.VIEW_NEW_CHANNEL));
  };

  const buttons: HeaderButton[] = [
    {
      title: 'Back',
      color: 'secondary',
      action: () => {
        dispatch(viewStackPop());
      },
      label: [<FontIcon className="mr-1" key="back" icon="chevron-left" />, 'Back'],
      side: 'left',
    },
  ];

  return (
    <div>
      <HeaderV3 borderBottom buttons={buttons}>
        Create
      </HeaderV3>
      <div className="CreateNewConversation">
        <WorkChatListItem
          asButton
          testId="workchat-create-new-message-button"
          ariaLabel="Create new Message"
          onClick={handleNewMessageClick}
          slotPrimary={
            <div className="channel-type-icon">
              <FontIcon icon="employees" />
            </div>
          }
          slotContent={
            <Fragment>
              <div className="content-top">
                <h3 className="title">Message</h3>
              </div>
              <div className="content-bottom">
                <span>Directly message one or more people.</span>
              </div>
            </Fragment>
          }
        />

        <WorkChatListItem
          asButton
          testId="workchat-create-new-channel-button"
          ariaLabel="Create new Channel"
          onClick={handleNewChannelClick}
          slotPrimary={
            <div className="channel-type-icon">
              <FontIcon icon="publish-and-notify" />
            </div>
          }
          slotContent={
            <Fragment>
              <div className="content-top">
                <h3 className="title">Channel</h3>
              </div>
              <div className="content-bottom">Start a group conversation by topic.</div>
            </Fragment>
          }
        />
      </div>
    </div>
  );
}
